export default "__VITE_ASSET__r8jG$1tQ__"